export const SocketRoles = {
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT'
}

export const SocketStyles = {
  WAITING_ROOM: { background: 'var(--secondary-color-30)' },
  NEEDS_ATTENTION: { background: 'var(--warning-color-30)' },
  WARNING: { background: 'var(--warning-color-10)' }
}

export const SocketLabels = {
  WAITING_ROOM: ' (En sala de espera)',
  NEEDS_ATTENTION: ' (¡Necesita atención!)'
}
